import { render, staticRenderFns } from "./ManagerSchoolHeader.vue?vue&type=template&id=3f51f41b&"
import script from "./ManagerSchoolHeader.vue?vue&type=script&lang=js&"
export * from "./ManagerSchoolHeader.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSchoolHeader.vue?vue&type=style&index=0&id=3f51f41b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports